import { Avatar as MUIAvatar, AvatarProps as MUIAvatarProps } from '@mui/material';

function getInitials(name: string): string {
    const nameParts = name.trim().split(' ');
    const firstNameInitial = nameParts[0][0];
    const lastNameInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : '';

    if (!firstNameInitial) {
        return '';
    }

    if (!lastNameInitial) {
        return firstNameInitial.toUpperCase();
    }

    return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
}

function stringAvatar(name: string, bgcolor?: string) {
    return {
        children: getInitials(name),
        sx: {
            backgroundColor: bgcolor,
            fontFamily: "'Mier B', sans-serif",
            fontWeight: 600,
            fontSize: '0.75rem',
        },
    };
}

function srcAvatar(src: string) {
    return {
        src,
        sx: {
            backgroundColor: 'purple.500',
        },
    };
}

interface AvatarProps extends MUIAvatarProps {
    name: string;
    src?: string;
    bgcolor?: string;
}

export default function Avatar({ name, bgcolor = '', src = '', sx, ...props }: AvatarProps) {
    const avatarProps = src ? srcAvatar(src) : stringAvatar(name, bgcolor);

    return (
        <MUIAvatar
            {...avatarProps}
            imgProps={{
                loading: 'lazy',
                sx: {
                    objectFit: 'cover',
                    objectPosition: 'center',
                },
            }}
            sx={{
                ...sx,
                ...avatarProps.sx,
            }}
            {...props}
        />
    );
}
